<template>
    <BreadCrumb PageTitle="Générer une facture" />
    <GenererFacture />
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import GenererFacture from "../../components/Facture/GenererFacture.vue";
  
    export default defineComponent({
      name: "GenererFacturePage",
      components: {
        BreadCrumb,
        GenererFacture,
      },
    });
  </script>